<!--
  ~ Copyright (c) Akveo 2019. All Rights Reserved.
  ~ Licensed under the Single Application / Multi Application License.
  ~ See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
  -->

<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a *ngIf="headerLogo.length > 0" class="logo" href="#" (click)="navigateHome()"><img [src]=headerLogo class="img-fluid"></a>
    <a *ngIf="headerLogo.length == 0" class="logo d-none d-md-block" href="#" (click)="navigateHome()">{{siteName}}</a>
    <a *ngIf="headerLogo.length == 0" class="logo d-md-none" href="#" (click)="navigateHome()">{{siteNameSmall}}</a>
  </div>
</div>

<div class="header-container">
  <nb-actions size="small">
    <nb-action class="user-action"  *nbIsGranted="['view', 'profile']">
      <nb-user class="tour-toggle" [nbContextMenu]="userMenu" [name]="user?.firstName + ' ' + user?.lastName"></nb-user>
    </nb-action>
  </nb-actions>
</div>
